<template>
  <div class="app-donations">
    <div class="top">
      <p class="intro-text">
        The Rubies COVID Charity Fund was set up to help provide food, monetary
        relief <br />
        and other forms of support to Nigerians who are at risk during this
        time. <br />
        This fund supports several organizations. <br />
        <br />
        To become an organization send us a mail.
        <a
          href="mailto:donate@rubies.ng?&subject=I Want to Enlist as An NGO on donate.rubies.ng"
          >here</a
        >.
      </p>
      <div class="row">
        <div class="col-sm-6">
          <SocialShareModal />
        </div>
        <div class="col-sm-6">
          <DonateNowModal />
        </div>
      </div>
    </div>

    <div class="bottom">
      <div class="search-box">
        <b-input-group class="mb-2" placeholder="Search donations">
          <b-input-group-prepend is-text>
            <b-icon icon="search"></b-icon>
          </b-input-group-prepend>
          <b-form-input
            type="search"
            class="search-input"
            placeholder="Search donations"
            v-model="query"
          ></b-form-input>
        </b-input-group>
      </div>

      <div class="donations-table">
        <div class="donations-table-wrap">
          <NonBlockingLoader v-if="loader.tableLoader" />
          <div v-else class="row">
            <div v-for="dnt in queryResults" :key="dnt.id" class="col-12">
              <DonationCard :donation="dnt" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style></style>

<script>
import SocialShareModal from "../Modal/SocialShareModal";
import DonateNowModal from "../Modal/DonateNowModal";
import DonationCard from "../Cards/DonationCard";
import { mapState } from "vuex";
import NonBlockingLoader from "../Utility/NonBlockingLoader";
import fz from "fuzzaldrin-plus";

export default {
  name: "AppLanding",
  components: {
    DonationCard,
    SocialShareModal,
    DonateNowModal,
    NonBlockingLoader
  },
  data() {
    return {
      query: ""
    };
  },
  computed: {
    ...mapState(["donation", "loader"]),
    queryResults() {
      if (!this.query) return this.donation.donations;

      const preparedQuery = fz.prepareQuery(this.query);
      const scores = {};

      return this.donation.donations
        .map(donation => {
          const scorableFields = [
            donation.id,
            donation.nameofdonor,
            donation.amount,
            donation.datecreated
          ].map(toScore => fz.score(toScore, this.query, { preparedQuery }));

          scores[donation.id] = Math.max(...scorableFields);

          return donation;
        })
        .filter(donation => scores[donation.id] > 1)
        .sort((a, b) => scores[b.id] - scores[a.id]);
    }
  },
  created() {
    this.$store.dispatch("donation/getAllDonations", null, { root: true });
  }
};
</script>
<style>
.search-input {
  outline: none;
}
.search-input:active,
.search-input:focus {
  outline: none;
}
</style>
